var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05859 3.75H13.7645",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64697 3.75H12.1764V13.3929C12.1764 13.677 12.0648 13.9496 11.8663 14.1505C11.6677 14.3514 11.3984 14.4643 11.1176 14.4643H3.7058C3.42497 14.4643 3.15566 14.3514 2.95709 14.1505C2.75853 13.9496 2.64697 13.677 2.64697 13.3929V3.75Z",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76465 3.74993V3.21422C4.76465 2.50382 5.04353 1.82251 5.53995 1.32018C6.03637 0.81785 6.70966 0.535645 7.41171 0.535645C8.11375 0.535645 8.78704 0.81785 9.28346 1.32018C9.77988 1.82251 10.0588 2.50382 10.0588 3.21422V3.74993",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82324 6.96582V11.2532",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.96582V11.2532",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8235,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.208cc1b2aab00362e45e1c3d809ba541.svg";
export { ForwardRef as ReactComponent };